import { LoaderFunction } from 'react-router';
import { Paths } from '@src/routes/paths';
import { getActiveUser } from '@src/auth/tokenRefresh';

export default (async ({ request }) => {
  // An expired access token does not mean the user is logged out: the Keycloak
  // SSO session outlives it by a long way, so renew in place. Previously this
  // only looked at expires_in and sent anyone with a stale token to /login,
  // which is what made returning to a suspended tab look like a logout.
  const user = await getActiveUser();
  if (user) {
    return null;
  } else {
    const url = new URL(request.url);
    const returnTo = url.pathname + url.search; // Include search parameters
    return Response.redirect(
      Paths.LOGIN + '?returnTo=' + encodeURIComponent(returnTo),
    );
  }
}) satisfies LoaderFunction;
